import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationFormService } from '@features/application-forms/services/application-forms.service';

@Pipe({
  name: 'ycFormDueDate'
})
export class FormDueDatePipe implements PipeTransform {
  constructor (
    private applicationFormsService: ApplicationFormService
  ) { }

  transform (date: string) {
    return this.applicationFormsService.formatDueDate(date);
  }
}
